module.exports = __webpack_public_path__ + "static/media/the_traveling_seven_family_2021_spain.8c91a365.jpeg";